import { AgGridReact } from "ag-grid-react";
import { EQM2010_R01DetailDto } from "./Dto_EQM2010_R01";
import { useRef, useMemo, useState, useCallback } from "react";
import { ColDef } from "ag-grid-community";
import { getDefaultRowIndexColumnConfig } from "src/utils/grid/gridStyleUtils";
import { getRowStyleFlags } from "src/utils/grid/gridStyleUtils";
import { createCellCssClassRules, createGridDropDownCommitAfter, GridCellConfig, InsertRowHandler } from "src/utils/grid/GridHandlerContent";
import { RemoveRowHandler } from "src/utils/grid/GridHandlerContent";
import { useRowSelectionHandler } from "src/utils/grid/GridHandlerContent";
import { GridCustomColumnDefs } from "src/utils/grid/GridCustomColumnDefs";
import { buildDefaultColumnStateFromDefs } from "src/utils/grid/columnPinUtils";
import { aggridHeaderClass, aggridSwitchButtonWrapperStyle } from "src/components/common/common";
import { defaultEQM2010_R01DetailDto } from "./Dto_EQM2010_R01";
import { useEQM2010_R01Store } from "./Store_EQM2010_R01";
import { useGridSettingContent } from "src/utils/grid/GridSettingContent";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Excel from "src/components/common/gridWrapper/Grid_Excel";
import { PostSortRowsParams } from "ag-grid-community";
import { postSortHandler } from "src/utils/grid/GridHandlerContent";
import { defaultColDef } from "src/utils/grid/gridStyleUtils";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { CommonCodeColumn, getCommonCodeColumnOptions } from "src/utils/grid/GridColumnContent";
import { getSwitchButtonColumnOptions } from "src/utils/grid/GridHandlerContent";
import {useCommonCodeStore} from "src/store/useCommonCodeStore";


 // 코드 검색 팝업 및 로직을 처리하는 커스텀 훅입니다.
import useUiuxStore from "src/store/useUiuxStore"; // 모달, 팝업 등 전역적인 UI/UX 상태를 관리하는 Zustand 스토어 훅입니다.
import { showWarning } from "src/utils/toast/toastUtil"; // 사용자에게 경고 메시지를 보여주는 토스트 유틸리티 함수입니다.
import { useCodeSearch } from "src/hooks/useCodeSearch";


// localStorage에 그리드 컬럼 상태(너비, 순서 등)를 저장하기 위한 키입니다.
const DETAIL_COLUMN_STATE_KEY = 'EQM2010_R01-detail-grid-column-state';
const DEFAULT_EDITABLE_COLUMNS = ['inspectCd', 'inspectCycle', 'remark'];

// Props 인터페이스 정의: 이 컴포넌트가 부모로부터 받을 props의 타입을 지정합니다.
interface Props {
	gridRef: React.RefObject<AgGridReact<EQM2010_R01DetailDto> | null>; // AG-Grid 인스턴스에 접근하기 위한 ref 객체입니다.
	defaultEQM2010_R01DetailRow: EQM2010_R01DetailDto;
}

// 상세 테이블 컴포넌트 정의
export const DetailTable_EQM2010_R01 = (props: Props) => {
	const { gridRef, defaultEQM2010_R01DetailRow } = props;

    const { setCodeSearchModalProps } = useUiuxStore();
	const { cycleList, inspectionStatusList, yesNoList } = useCommonCodeStore();

    const { 
        selectedEQM2010_R01,
        EQM2010_R01DetailList, setEQM2010_R01DetailList,
        selectedEQM2010_R01DetailList, setSelectedEQM2010_R01DetailList, removeSelectedEQM2010_R01DetailList, addSelectedEQM2010_R01DetailList, initSelectedEQM2010_R01DetailList,
        deletedEQM2010_R01DetailList, setDeletedEQM2010_R01DetailList, addDeletedEQM2010_R01DetailList, removeDeletedEQM2010_R01DetailList,
        insertEQM2010_R01DetailList, updateEQM2010_R01DetailList, removeEQM2010_R01DetailList,
        EQM2010_R01List, setEQM2010_R01List,
        originalEQM2010_R01DetailList, setOriginalEQM2010_R01DetailList,
        detailColumnState, setDetailColumnState,
        detailScrollTop, setDetailScrollTop,
    } = useEQM2010_R01Store();
    // 클릭 가능 여부를 제어하는 상태 (더블클릭 등 이벤트 충돌 방지용)
    const [clickable, setClickable] = useState(true);

const { searchExactCode } = useCodeSearch({});
    
	//const gridRef = useRef<AgGridReact>(null);
	// 그리드 전체를 감싸는 div 요소에 대한 ref를 생성합니다. (컨텍스트 메뉴 등에 사용)
	const gridWrapperRef = useRef<HTMLDivElement>(null); // 1. div를 위한 ref 생성

    const {
		getRowId,
		createRowClassRules,
		createCellClassRules,
		paddedGridData,
		renderIndexCell,
		handleSwitchButtonHandler,
	} = useGridSettingContent({
		gridRef,
		key: 'valueIndex',
		gridData: EQM2010_R01DetailList,
		defaultGridData: defaultEQM2010_R01DetailRow,
		selectedRow: undefined, // selectedEQM2010_R01DetailList,
		originalGridData: originalEQM2010_R01DetailList,
		updateRow: (index: number, data: any) => updateEQM2010_R01DetailList(index, data),
	});
	
    
    const headerNames: Record<string, string> = {
		rowIndex: "",
		inspectCd: '점검코드',
		inspectNm: '점검명',
		inspectCycle: '점검주기',
		planYn: '점검여부',
		inspectMethod: '점검방법',
		inspectType: '점검유형',
		inspectValueNm: '결과유형',
		remark: '비고',
	}

	const cssCellConfig = useMemo<GridCellConfig>(() => ({
		disabledCells: ['inspectCd', 'inspectNm', 'inspectMethod', 'inspectType', 'inspectValue', 'inspectValueNm'],
		insertedDisabledCells: [''],
		commonDisabledCells: [''],
		pointerCells: ['inspectCycle', 'planYn', 'remark'],
		insertedPointerCells: [''],
		commonPointerCells: [''],
		alignLeftCells: [''],
	}), []);

	const {
		disabledInsertedColumns, disabledColumns,
		pointerInsertedColumns, pointerColumns,
		alignLeftColumns,
	} = useMemo(() => createCellCssClassRules(cssCellConfig), [cssCellConfig]);
	
	const cellCssDefaultColDef = useMemo(() => {
        const baseRules = createCellClassRules<EQM2010_R01DetailDto>({
            idKey: 'valueIndex',
            selectedList: selectedEQM2010_R01DetailList,
            deletedList: deletedEQM2010_R01DetailList,
            disabledInsertedColumns,	disabledColumns,
            pointerInsertedColumns,		pointerColumns,
            alignLeftColumns,
        });

        return { ...defaultColDef, cellClassRules: { ...baseRules, }}; 
	}, [
		createCellClassRules,
        selectedEQM2010_R01DetailList, deletedEQM2010_R01DetailList,
        disabledInsertedColumns, disabledColumns,         
        pointerInsertedColumns, pointerColumns,
		alignLeftColumns,
    ]);
	

	// 이 화면(EQM2010)을 위한 모듈 설정을 생성합니다.
	const EQM2010_R01Config = createModuleConfig.EQM2010();

	const fieldConfigWithSearch = {
		...EQM2010_R01Config.fieldConfig,
		codeSearchFields: {
			...EQM2010_R01Config.fieldConfig.codeSearchFields,
			inspectCd: {
				...EQM2010_R01Config.fieldConfig.codeSearchFields!.inspectCd,
				searchFunction: (code: string, onSuccess?: (item: any) => void) => 
					searchExactCode('inspect', code, onSuccess)
			}
		}
	};

	const calculateAmount = useCallback((data: EQM2010_R01DetailDto) => {
		return data;
	}, []);



    //  편집 가능한 컬럼 ID 목록을 정의합니다.
	const handleGridDropDownCommitAfter = useMemo(() => 
		createGridDropDownCommitAfter<EQM2010_R01DetailDto>(DEFAULT_EDITABLE_COLUMNS),
	[],);

    // useMemo를 사용하여 그리드의 기본 컬럼 정의를 생성합니다. (의존성이 변경될 때만 재생성)
    const baseColumnDefs: ColDef<EQM2010_R01DetailDto>[] = useMemo(() => [
		// 그리드 행 번호와 +/- 버튼을 표시하는 컬럼 설정
		...getDefaultRowIndexColumnConfig(
			(params: EQM2010_R01DetailDto) => renderIndexCell(
				params, 
				// 행의 상태(삭제, 선택 등)에 따라 스타일 플래그를 가져오는 함수
				(innerParams: EQM2010_R01DetailDto) => getRowStyleFlags (
					innerParams,
					{
						deletedList: deletedEQM2010_R01DetailList,
						selectedList: selectedEQM2010_R01DetailList,
						dataList: EQM2010_R01DetailList
					}),
					
				() => {}, // + 버튼 클릭 핸들러 (사용 안 함으로 빈 함수 전달)
				// - 버튼 클릭 핸들러 (행 삭제 로직)
				(rowData) => RemoveRowHandler( 
					gridRef,
					EQM2010_R01DetailList, 
					rowData,  // rowData는 renderIndexCell에서 Dto 형식으로 선언함
					setClickable, 
					removeEQM2010_R01DetailList, 
					(valueIndex) => addDeletedEQM2010_R01DetailList([valueIndex.toString()])
				),
			)
		),
		// 점검코드 컬럼
		{
			headerName: '점검코드', colId: 'inspectCd', field: 'inspectCd', width: 77,
			editable: false, // 편집 불가 (더블클릭으로 팝업을 띄우기 때문)
		
		},
		// 점검명 컬럼
		{
			headerName: '점검명', colId: 'inspectNm', field: 'inspectNm', width: 161,
			editable: false, // 편집 불가 (점검코드 선택 시 자동으로 채워짐)
		},
		// 점검주기 컬럼
		{
			headerName: '점검주기', colId: 'inspectCycle', field: 'inspectCycle', width: 127,
			...CommonCodeColumn.options(cycleList, true, CommonCodeColumn.change(updateEQM2010_R01DetailList), handleGridDropDownCommitAfter),
		},
		// 점검여부 컬럼
		{
			headerName: '점검여부', colId: 'planYn', field: 'planYn', width: 70,
			...getSwitchButtonColumnOptions('planYn', handleSwitchButtonHandler, headerNames, aggridSwitchButtonWrapperStyle, true),
		},
		// 점검방법 컬럼
		{
			headerName: '점검방법', colId: 'inspectMethod', field:  'inspectMethod', width: 130,
			editable: false, // 편집 불가 (점검코드 선택 시 자동으로 채워짐)
		},
		// 점검유형 컬럼
		{
			headerName: '점검유형', colId: 'inspectType', field: 'inspectType', width: 60,
			editable: (params) => EQM2010_R01DetailList[params.node.rowIndex!] !== undefined, // 빈 행이 아닐 때만 편집 가능
			comparator: (valueA, valueB) => Number(valueA) - Number(valueB),
			valueFormatter: (params) => params.value?.toLocaleString() ?? '',
			...CommonCodeColumn.options(inspectionStatusList, false, undefined, undefined),
		},
		// 결과유형 컬럼
		{
			headerName: '결과유형', colId: 'inspectValueNm', field: 'inspectValueNm', width: 90,
			editable: false, // 편집 불가 (점검코드 선택 시 자동으로 채워짐)
		},
		// 비고 컬럼
		{
			headerName: '비고', colId: 'remark', field: 'remark', width: 65,
			editable: (params) => EQM2010_R01DetailList[params.node.rowIndex!] !== undefined, // 빈 행이 아닐 때만 편집 가능
			comparator: (valueA, valueB) => Number(valueA) - Number(valueB), // 숫자 정렬
			valueFormatter: (params) => params.value?.toLocaleString() ?? '', // 숫자 포맷팅
			pasteable: true,  // inserted 여부 무관하게 Ctrl+V 허용
			valueParser: (params) => Number(String(params.newValue ?? '').replace(/,/g, '').trim()) || 0,
		},
		
	], [cycleList, deletedEQM2010_R01DetailList, EQM2010_R01DetailList, handleGridDropDownCommitAfter, inspectionStatusList, setCodeSearchModalProps, updateEQM2010_R01DetailList]);

	const defaultColumnState = useMemo(
		() => buildDefaultColumnStateFromDefs(baseColumnDefs, []),
	[baseColumnDefs]);

	// useMemo를 사용하여 최종 컬럼 정의를 생성합니다.
	const columnDefs: ColDef<EQM2010_R01DetailDto>[] = useMemo(() => {
		// 저장된 컬럼 상태(너비, 순서 등)가 없으면 기본 컬럼 정의를 사용합니다.
		if (detailColumnState === null) {
			return baseColumnDefs;
		}
		
		// 저장된 컬럼 상태가 있으면, 이를 기본 컬럼 정의에 적용하여 최종 컬럼을 생성합니다.
		return GridCustomColumnDefs<EQM2010_R01DetailDto>({
			baseColumnDefs,
			columnState: detailColumnState,
			headerNames,
			fallbackHeaderClass: aggridHeaderClass
		});
	}, [baseColumnDefs, detailColumnState, headerNames]);
	

	// 행 클릭 시 선택/해제 로직을 처리하는 핸들러 (커스텀 훅 사용)
	const handleRowClick = useRowSelectionHandler({
		dataList: EQM2010_R01DetailList, // 전체 데이터 리스트
		idKey: 'valueIndex', // 행 고유 식별자 필드
		selectedList: selectedEQM2010_R01DetailList, // 현재 선택된 행 리스트
		deletedList: deletedEQM2010_R01DetailList, // 현재 삭제된 행 리스트
		addSelected: addSelectedEQM2010_R01DetailList, // 선택 목록에 추가하는 함수
		removeSelected: removeSelectedEQM2010_R01DetailList, // 선택 목록에서 제거하는 함수
		clickable, setClickable // 클릭 가능 상태 및 설정 함수
	});


    // 공통 상세 테이블 핸들러 훅을 사용하여 셀 변경, 편집 종료 등의 이벤트를 처리합니다.
    const detailTableHandlers = useCommonDetailTableHandlers<EQM2010_R01DetailDto>({
		detailList: EQM2010_R01DetailList, // 상세 데이터 리스트
		updateDetailList: updateEQM2010_R01DetailList, // 데이터 업데이트 함수
		originalDetailList: originalEQM2010_R01DetailList, // 원본 데이터 리스트
		setCodeSearchModalProps, // 코드 검색 모달을 여는 함수
		gridRef, // 그리드 ref
		fieldConfig: fieldConfigWithSearch, // 필드 설정 (검색 함수 포함)
		codeSearchConfig: EQM2010_R01Config.codeSearchConfig, // 코드 검색 설정
		calculateAmount, // 금액 계산 함수
	});
    

	// 행 드래그 중인지 여부를 추적하기 위한 ref
	const isRowDraggingRef = useRef(false); 


    //  셀 더블클릭 이벤트 핸들러 (점검코드 검색)
    const handleCellDoubleClick = useCallback((params: any) => {
        // '점검코드' 컬럼에서 더블클릭이 발생했을 때만 동작
        if (params.colDef.colId === 'inspectCd') {
            // 설비점검 코드 검색 모달을 엽니다.
            setCodeSearchModalProps({
                category: '설비점검코드', // 검색할 코드의 카테고리
                search: params.value || '', // 현재 셀의 값으로 초기 검색
                formName: 'EQM2010_R01', // 이 화면의 식별자
                rowIndex: params.node.rowIndex, // 현재 행의 인덱스
                handleFoucsId: `inspectCd_${params.node.rowIndex}`, // 모달이 닫힌 후 포커스를 돌려줄 요소의 ID
                //  메인 그리드에서 선택된 설비의 '설비유형'으로 검색 결과를 필터링합니다.
                extraFilter: selectedEQM2010_R01?.equipmentType ? { eqmType: selectedEQM2010_R01.equipmentType } : {},
                // 확인 버튼 클릭 시 실행될 콜백
                onConfirm: (selectedItem: any) => {
                    //  (주석 처리됨) 설비 유형 유효성 검사. 필터링으로 대체.
                    // if (!validateEquipmentType(selectedItem)) {
                    //     return; // 검증 실패 시 적용하지 않음
                    // }
                    
                    // 선택된 점검 정보를 해당 행에 적용
                    const rowIndex = params.node.rowIndex;
                    const updatedData = {
                        ...EQM2010_R01DetailList[rowIndex],
                        inspectCd: selectedItem.inspectCd,
                        inspectNm: selectedItem.inspectNm,
                        inspectMethod: selectedItem.inspectMethod,
                        inspectType: selectedItem.inspectType,
                        inspectValue: selectedItem.inspectValue,
                        inspectValueNm: selectedItem.inspectValueNm ?? selectedItem.inspectValue,
                        remark: selectedItem.remark,
                        isModified: true // 수정되었음을 표시
                    };
                    updateEQM2010_R01DetailList(rowIndex, updatedData);
                },
                // 지우기 버튼 클릭 시 실행될 콜백
                onClear: () => {
                    // 현재 행의 점검 관련 필드를 모두 비웁니다.
                    const rowIndex = params.node.rowIndex;
                    const clearedData = {
                        ...EQM2010_R01DetailList[rowIndex],
                        inspectCd: '',
                        inspectNm: '',
                        inspectMethod: '',
                        inspectType: '',
                        inspectValue: '',
                        inspectValueNm: '',
                        remark: '',
                        isModified: true // 수정되었음을 표시
                    };
                    updateEQM2010_R01DetailList(rowIndex, clearedData);
                }
            });
        }
    }, [EQM2010_R01DetailList, setCodeSearchModalProps, updateEQM2010_R01DetailList, selectedEQM2010_R01?.equipmentType]); // 의존성 배열에 selectedEQM2010_R01?.equipmentType 추가

    //  셀에서 키보드 이벤트 발생 시 핸들러 (Enter 키로 점검코드 검색)
    const handleCellKeyDown = useCallback((params: any) => {
		// 'Enter' 키가 눌렸고, '점검코드' 컬럼일 때 동작
		if (params.event.key === 'Enter' && params.colDef.colId === 'inspectCd') {
			const inputValue = params.event.target.value?.trim(); // 입력된 값 (공백 제거)
			if (inputValue) {
				// (주석 처리됨) 설비유형 필터 적용 부분. 현재는 사용하지 않음.
				const filters = selectedEQM2010_R01?.equipmentType ? { eqmType: selectedEQM2010_R01.equipmentType } : {};
				
				// 입력된 코드로 정확히 일치하는 점검코드를 검색합니다.
				searchExactCode('inspect', inputValue).then((foundItem: any) => {
					if (foundItem) { // 검색 결과가 있으면
						
						const valueIndex = params.data.valueIndex; // 행의 고유 ID
						// 검색된 점검 정보로 현재 행의 데이터를 업데이트합니다.
						const updatedData = {
							...params.data, 
							inspectCd: foundItem.inspectCd,
							inspectNm: foundItem.inspectNm,
							inspectMethod: foundItem.inspectMethod,
							inspectType: foundItem.inspectType,
							inspectValue: foundItem.inspectValue,
							inspectValueNm: foundItem.inspectValueNm ?? foundItem.inspectValue,
							remark: foundItem.remark,
							isModified: true // 수정되었음을 표시
						};
						updateEQM2010_R01DetailList(valueIndex, updatedData);
					}
				});
			}
		}
	}, [searchExactCode, updateEQM2010_R01DetailList, selectedEQM2010_R01?.equipmentType]); // 의존성 배열에 selectedEQM2010_R01?.equipmentType 추가

    //  셀 클릭 이벤트 핸들러 (편집 시작)
    const handleCellClick = useCallback((params: any) => {
        // 편집 가능한 컬럼 목록에 포함된 컬럼일 경우
        if (DEFAULT_EDITABLE_COLUMNS.includes(params.colDef.colId)) {
            // 해당 셀의 편집을 시작합니다.
            params.api.startEditingCell({
                rowIndex: params.node.rowIndex,
                colKey: params.colDef.colId
            });
        }
    }, []);

    //  정렬 후 실행되는 핸들러
    const handlePostSort = useCallback((params: PostSortRowsParams<EQM2010_R01DetailDto>) => {
		// 행을 드래그하는 중에는 자동 정렬을 막습니다.
		if (isRowDraggingRef.current) return;
		// 공통 정렬 후 처리 함수를 호출하여 데이터 순서를 맞춥니다.
		postSortHandler(params, EQM2010_R01DetailList, originalEQM2010_R01DetailList, setEQM2010_R01DetailList);
	}, [EQM2010_R01DetailList, originalEQM2010_R01DetailList, ]);


	// 그리드 하단에 고정될 행(pinned bottom row)의 데이터를 생성합니다. (총 건수 표시)
	const pinnedBottomRowData = useMemo(() => {
		return [{
			// equipmentCd 필드를 사용하여 총 건수를 표시 (필드명은 중요하지 않음, 위치가 중요)
			equipmentCd: EQM2010_R01DetailList.length.toLocaleString() + "건",
		}];	  
	}, [EQM2010_R01DetailList, deletedEQM2010_R01DetailList,]);

	// 삭제된 행들의 ID 리스트를 정규화합니다. (숫자 형태의 ID만 필터링)
	const normalizedDeletedIds = useMemo(() => {
		return deletedEQM2010_R01DetailList
			.filter((v) => /^\d+$/.test(String(v))) // 숫자 형식의 문자열만 필터링
			.map((v) => Number(v)); // 숫자로 변환
	}, [deletedEQM2010_R01DetailList]);

	// 🚨 수정: 행의 상태(선택, 삭제 등)에 따라 CSS 클래스를 적용하는 규칙을 생성합니다.
	const rowClassRules = createRowClassRules<EQM2010_R01DetailDto>({
		idKey: 'valueIndex', // 행 고유 식별자 필드
		selectedList: selectedEQM2010_R01DetailList, // 선택된 행 리스트
		deletedList: normalizedDeletedIds, // 삭제된 행 리스트
	});

	// 셀 값이 변경되었을 때 실행되는 핸들러
	const handleCellValueChanged = useCallback((e: any) => {
		// 공통 핸들러를 호출하여 isModified 플래그 등을 처리
		detailTableHandlers.handleCellChange(e);
		// 하단 고정 행은 처리하지 않음
		if (e.node?.rowPinned === 'bottom') return;
		// '점검주기' 컬럼의 값이 변경되었을 경우
		if (e.colDef?.field === 'inspectCycle' && e.newValue !== e.oldValue) {
			const valueIndex = e.data?.valueIndex;
			if (typeof valueIndex === 'number') {
				const latest = EQM2010_R01DetailList.find(d => d.valueIndex === valueIndex) || e.data;
				// '점검여부(planYn)'를 'Y'로 자동 변경 (저장 전 UI상 변경)
				updateEQM2010_R01DetailList(valueIndex, { ...latest, planYn: 'Y', isModified: latest.inserted ? false : true });
			}
		}
	}, [detailTableHandlers, EQM2010_R01DetailList, updateEQM2010_R01DetailList]);


	// JSX 렌더링
	return(
    // 그리드 컨텍스트 메뉴(우클릭 메뉴)를 제공하는 래퍼 컴포넌트
    <GridContextWrapper<EQM2010_R01DetailDto>
        gridWrapperRef={gridWrapperRef} // 그리드 래퍼 div의 ref
        gridRef={gridRef} // 그리드 인스턴스의 ref
        paddedGridData={paddedGridData} // 빈 행이 포함된 데이터
        enableCellCalculation
        setPaddedGridData={setEQM2010_R01DetailList} // 데이터 설정 함수
        initSelected={initSelectedEQM2010_R01DetailList} // 선택 초기화 함수
		defaultRowData={defaultEQM2010_R01DetailRow}
        baseColumnDefs={detailColumnState ? columnDefs : baseColumnDefs}
        defaultColumnState={defaultColumnState}
        setColumnState={setDetailColumnState} // 컬럼 상태 설정 함수
        localStorageKey={DETAIL_COLUMN_STATE_KEY} // localStorage 키
        menuItems={undefined} // 컨텍스트 메뉴 아이템 (여기서는 사용 안 함)
    >
        
        <Grid_Excel<EQM2010_R01DetailDto>
            ref={gridRef}
            rowData={paddedGridData}
            getRowId={getRowId}
            columnDefs={columnDefs}
            defaultColDef={cellCssDefaultColDef}
            disableBuiltinCellSelection={true}
            columnStateKey={DETAIL_COLUMN_STATE_KEY}
            setColumnState={setDetailColumnState}
            getDefaultColumnState={() => defaultColumnState}
            scrollTop={detailScrollTop}
            setScrollTop={setDetailScrollTop}
            rowClassRules={rowClassRules}
            onRowClicked={handleRowClick}
            onCellClicked={handleCellClick}
            onCellDoubleClicked={handleCellDoubleClick}
            onCellKeyDown={handleCellKeyDown}
            onCellValueChanged={handleCellValueChanged}
            onCellEditingStopped={detailTableHandlers.handleCellEditingStopped}
            pinnedBottomRowData={pinnedBottomRowData}
            rowDragManaged={true}
            rowDragEntireRow={true}
            onRowDragEnter={() => { isRowDraggingRef.current = true; }}
            onRowDragEnd={(e: any) => {
                const api = e.api;
                if (api.applyColumnState) {
                    api.applyColumnState({ defaultState: { sort: null as any, sortIndex: null as any } });
                }
                const reordered: EQM2010_R01DetailDto[] = [];
                api.forEachNodeAfterFilterAndSort((node: any, idx: number) => {
                    if (!node.data) return;
                    reordered.push({
                        ...node.data,
                        orderIndex: idx + 1,
                        orderIndexSeq: 0,
                    });
                });
                setEQM2010_R01DetailList(reordered);
                isRowDraggingRef.current = false;
            }}
            onPostSortRows={handlePostSort}
        />
    </GridContextWrapper>
    )
}
